angular.module('nv.shared.background-job-ui', ['nv.shared.background-job-ui.background-job-progress']);
